import React from 'react';
import Grid from "@material-ui/core/es/Grid";
import grey from '@material-ui/core/colors/grey';
const grey600 = grey['600'];

export default ({label, content, autoSize}) => (
    <Grid container spacing={8} style={{padding: '10px'}}>
        <Grid item xs={autoSize ? undefined : 12} sm={autoSize ? undefined : 3} style={{color: grey600}}>
            {label}
        </Grid>
        <Grid item xs={autoSize ? undefined : 12} sm={autoSize ? undefined : 9}>
            {content}
        </Grid>
    </Grid>
)



// WEBPACK FOOTER //
// ./src/components/common/LabelAndText.js